import * as Yup from 'yup';
import { NumberIntegerMinOneRequired, NumberIntegerRequired, NumberRequired, StringRequired, ToTwoDecimal } from '../utils/dataValidations';

const sharedFieldsVenta1 = ({ disabled, urlApiAlmacen, user_id, tipo }) => {
    return [
        {
            label: 'Seleccione producto de almacén',
            name: 'almacen_producto_id',
            type: 'selectSearchDetailCard',
            urlApi: urlApiAlmacen,
            required: true,
            disabled: disabled != null ? disabled : false,
            labelDescription: 'etiqueta',
            placeholder: 'Producto...',
            autoFocus: true,
            nameNumber: 'cantidadAlmacen',
            labelNumberRestante: 'Restante',
            nameNumberRestante: 'cantidad_total_restante',
            alterField: 'cantidadTotal',
            exclamationDefault: 'Seleccione un producto!',
            exclamationRestante: 'Stock insuficiente!',
            infoTags: [
                {
                    label: 'Producto',
                    data: 'producto_nombre'
                },
                {
                    label: 'Tipo',
                    data: 'tipoProducto'
                },
                {
                    label: 'En almacén',
                    data: 'cantidadAlmacen',
                    mark: true
                },
            ]
        },
        {
            label: tipo === 'venta-retornable-oficina' || tipo === 'venta-no-retornable-oficina' ? 'Empresa/Mayorista' : 'Cliente',
            name: 'user_id',
            type: 'selectSearch',
            urlApi: `/vendedor/${user_id}/clientes?tag=${tipo === 'venta-retornable-oficina' || tipo === 'venta-no-retornable-oficina' ? 'cliente-mayor' : 'cliente-menor'}`,
            required: true,
            disabled: disabled != null ? disabled : false,
            labelDescription: 'etiqueta',
            placeholder: 'Cliente...',
            autoFocus: false,
        },
        {
            label: 'Precio unitario',
            name: 'precio_unitario',
            type: 'groupnumberCalculator',
            subData: 'Bs.',
            required: true,
            disabled: disabled != null ? disabled : false,
            ChangeCalculator: (values, setValues, e) => {
                const precio_unitario = e.target.valueAsNumber || 0;
                const cantidad = values.cantidad || 0;
                const venta_total = ToTwoDecimal(precio_unitario * cantidad);
                setValues('venta_total', venta_total)

                // const efectivo_total = values.efectivo_total || 0;
                // const deuda_total = ToTwoDecimal(venta_total - efectivo_total)
                // setValues('deuda_total', deuda_total)
                const efectivo_total = values.efectivo_total || 0
                const transferencia_total = values.transferencia_total || 0
                const deuda_total = ToTwoDecimal(venta_total - efectivo_total - transferencia_total)
                setValues('deuda_total', deuda_total)
            }
        },
        {
            label: 'Cantidad',
            name: 'cantidad',
            type: 'numberCalculator',
            subData: null,
            required: true,
            disabled: disabled != null ? disabled : false,
            locked: false,
            ChangeCalculator: (values, setValues, e) => {
                const cantidad = e.target.valueAsNumber || 0;
                const precio_unitario = values.precio_unitario || 0;
                const venta_total = ToTwoDecimal(precio_unitario * cantidad);
                setValues('venta_total', venta_total)

                // const efectivo_total = values.efectivo_total || 0;
                // const deuda_total = ToTwoDecimal(venta_total - efectivo_total)
                // setValues('deuda_total', deuda_total)
                const efectivo_total = values.efectivo_total || 0
                const transferencia_total = values.transferencia_total || 0
                const deuda_total = ToTwoDecimal(venta_total - efectivo_total - transferencia_total)
                setValues('deuda_total', deuda_total)


                const cantidad_retorno = values.cantidad_retorno || 0
                const cantidad_deuda = cantidad - cantidad_retorno
                setValues('cantidad_deuda', cantidad_deuda)

                const cantidad_total = values.cantidadAlmacen || 0
                const total = ToTwoDecimal(cantidad_total - cantidad)
                setValues('cantidad_total_restante', total < 0 ? 0 : total)
            }
        },
    ]
}
const sharedFieldsVenta2 = ({ disabled, tipo }) => {
    return [
        {
            label: 'Método de pago',
            name: 'metodo_pago',
            type: 'select',
            required: true,
            disabled: disabled != null ? disabled : false,
            options: [
                {
                    label: 'Efectivo',
                    value: 'efectivo'
                },
                {
                    label: 'Transferencia',
                    value: 'transferencia'
                },
                {
                    label: 'Cheque',
                    value: 'cheque'
                },
                {
                    label: 'Combinado E/T',
                    value: 'combinado'
                },
            ],
        },
        {
            label: 'Total venta',
            name: 'venta_total',
            type: 'groupnumber',
            subData: 'Bs.',
            required: true,
            disabled: true,
            highlight: 'bg-blue-600 dark:bg-blue-500 bg-opacity-25 dark:bg-opacity-20'
        },
        {
            label: 'En efectivo',
            name: 'efectivo_total',
            type: 'groupnumberCalculator',
            subData: 'Bs.',
            required: true,
            disabled: disabled != null ? disabled : false,
            ChangeCalculator: (values, setValues, e) => {
                const efectivo_total = e.target.valueAsNumber || 0;
                const transferencia_total = values.transferencia_total || 0;
                const venta_total = values.venta_total || 0
                const deuda_total = ToTwoDecimal(venta_total - efectivo_total - transferencia_total)
                setValues('deuda_total', deuda_total)
            },
            ChangeCondition: (values, setValues, setAditionalClass) => {
                const visible = ['efectivo', 'combinado'].includes(values.metodo_pago)
                
                if (visible) {
                    setAditionalClass('')
                } else {
                    setAditionalClass('hidden')
                    if (Number(values.efectivo_total || 0) !== 0) {
                        setValues('efectivo_total', 0)
                    }
                    const vt = Number(values.venta_total || 0)
                    const tr = Number(values.transferencia_total || 0)
                    setValues('deuda_total', ToTwoDecimal(vt - 0 - tr))
                }
            },
            fieldDependency: 'metodo_pago',
            highlight: 'bg-green-600 dark:bg-green-500 bg-opacity-25 dark:bg-opacity-20'
        },
        {
            label: 'Por transferencia',
            name: 'transferencia_total',
            type: 'groupnumberCalculator',
            subData: 'Bs.',
            required: true,
            disabled: disabled != null ? disabled : false,
            ChangeCalculator: (values, setValues, e) => {
                const transferencia_total = e.target.valueAsNumber || 0;
                const efectivo_total = values.efectivo_total || 0;
                const venta_total = values.venta_total || 0
                const deuda_total = ToTwoDecimal(venta_total - transferencia_total - efectivo_total)
                setValues('deuda_total', deuda_total)
            },
            ChangeCondition: (values, setValues, setAditionalClass) => {
                const visible = ['transferencia', 'cheque', 'combinado'].includes(values.metodo_pago)
                
                if (visible) {
                    setAditionalClass('')
                } else {
                    setAditionalClass('hidden')
                    if (Number(values.transferencia_total || 0) !== 0) {
                        setValues('transferencia_total', 0)
                    }
                    const vt = Number(values.venta_total || 0)
                    const ef = Number(values.efectivo_total || 0)
                    setValues('deuda_total', ToTwoDecimal(vt - ef - 0))
                }
            },
            fieldDependency: 'metodo_pago',
            highlight: 'bg-gray-600 dark:bg-gray-500 bg-opacity-25 dark:bg-opacity-20'
        },
        {
            label: 'Saldo',
            name: 'deuda_total',
            type: 'groupnumber',
            subData: 'Bs.',
            required: true,
            disabled: true,
            highlight: 'bg-red-600 dark:bg-red-500 bg-opacity-25 dark:bg-opacity-20'
        },
        {
            label: 'Fecha estimada de cobro',
            name: 'fecha_estimada_cobro',
            type: 'date',
            required: false,
            disabled: disabled != null ? disabled : false,
            ChangeCondition: (values, setValues, setAditionalClass) => {
                if (values.deuda_total > 0)
                    setAditionalClass('')
                else
                    setAditionalClass('hidden')
            },
            fieldDependency: 'deuda_total',
            highlight: 'bg-gray-600 dark:bg-gray-500 bg-opacity-25 dark:bg-opacity-20'
        },
    ]
}

const sharedEncargadoObs = ({ tipo }) => {
    return [
        {
            type: 'divider'
        },
        tipo === 'venta-retornable-oficina' || tipo === 'venta-no-retornable-oficina' ?
            {
                label: 'Encargado de entrega',
                name: 'encargado_id',
                type: 'selectSearch',
                urlApi: `/vendedores`,
                required: false,
                labelDescription: 'nombre',
                placeholder: 'Encargado...',
                autoFocus: false,
            }
            :
            {},
        // ,
        tipo === 'venta-retornable-oficina' || tipo === 'venta-no-retornable-oficina' || tipo === 'oficina' ?
            {
                label: 'Nro. Boleta',
                name: 'nro_boleta',
                type: 'text',
                required: false,
                placeholder: '#Nro...',
                autoFocus: false
            }
            :
            {}
        ,
        tipo === 'venta-retornable-oficina' || tipo === 'venta-no-retornable-oficina' || tipo === 'oficina' ?
            {
                type: 'divider'
            }
            :
            {}
        ,
        {
            label: 'Observaciones',
            name: 'obs',
            type: 'textArea',
            required: false,
            placeholder: 'Observaciones...',
            autoFocus: false
        },
    ]
}
const sharedInitialValuesVenta = ({ cuaderno_id, tipo }) => {
    return {
        cuaderno_id: cuaderno_id,
        almacen_producto_id: '',
        cantidadTotal: 0,
        cantidad_total_restante: 0,
        user_id: '',
        tipo: tipo,
        precio_unitario: 0,
        cantidad: 0,
        metodo_intercambio: 'normal',
        metodo_pago: 'efectivo',
        venta_total: 0,
        efectivo_total: 0,
        deuda_total: 0,
        transferencia_total: 0,
        fecha_estimada_cobro: '',
        obs: '',
        // 
        encargado_id: '',
        nro_boleta: '',
    }
}

export const VentaRetornableValues = (cuaderno_id, user_id, tipo, disabled = null) => {
    return {
        initialValues: {
            ...sharedInitialValuesVenta({ cuaderno_id, tipo }),
            cantidad_retorno: 0,
            cantidad_deuda: 0,
            metodo_pago_garantia: 'efectivo',
            monto_garantia: 0,
            monto_garantia_transferencia: 0,
            fecha_estimada_devolucion: '',
        },
        fieldsValidation: Yup.object().shape({
            almacen_producto_id: StringRequired,
            cantidad_deuda: NumberIntegerRequired,
            precio_unitario: NumberRequired,
            cantidad: NumberIntegerMinOneRequired,
            cantidad_retorno: NumberIntegerRequired,
            deuda_total: Yup.number()
                .required('Campo requerido')
                .min(0, 'El saldo debe ser mayor o igual a 0'),
        }),
        fields: [
            ...sharedFieldsVenta1({ disabled, urlApiAlmacen: `/user/${user_id}/almacenes/retornable`, user_id, tipo }),
            {
                label: 'Cantidad recojidos',
                name: 'cantidad_retorno',
                type: 'numberCalculator',
                subData: null,
                required: true,
                disabled: disabled != null ? disabled : false,
                ChangeCalculator: (values, setValues, e) => {
                    const cantidad_retorno = e.target.valueAsNumber || 0;
                    const cantidad = values.cantidad || 0
                    const cantidad_deuda = cantidad - cantidad_retorno
                    setValues('cantidad_deuda', cantidad_deuda)
                },
            },
            {
                label: 'Cantidad deuda',
                name: 'cantidad_deuda',
                type: 'number',
                subData: null,
                required: true,
                disabled: true,
                highlight: 'bg-yellow-600 dark:bg-yellow-500 bg-opacity-25 dark:bg-opacity-20',
                locked: true,
                ChangeCondition: (values, setValues, setAditionalClass) => {
                    const cantidad_retorno = values.cantidad_retorno || 0
                    const cantidad = values.cantidad || 0
                    const cantidad_deuda = cantidad - cantidad_retorno
                    setValues('cantidad_deuda', cantidad_deuda)
                },
                fieldDependency: 'cantidad',
            },
            {
                label: 'Garantía / Prestamo',
                name: 'metodo_intercambio',
                type: 'selectCondition',
                required: true,
                disabled: disabled != null ? disabled : false,
                options: [
                    {
                        label: 'Normal',
                        value: 'normal',
                        disabled: (values) => {
                            if (values.cantidad_deuda > 0)
                                return true
                        }
                    },
                    {
                        label: 'Garantía',
                        value: 'garantía',
                        disabled: (values) => {
                            if (values.cantidad_deuda <= 0)
                                return true
                        }
                    },
                    {
                        label: 'Prestamo',
                        value: 'préstamo',
                        disabled: (values) => {
                            if (values.cantidad_deuda <= 0)
                                return true
                        }
                    },
                ],
                ChangeCondition: (values, setValues, setAditionalClass) => {
                    if (values.cantidad_deuda > 0 && values.metodo_intercambio === 'normal')
                        setValues('metodo_intercambio', 'garantía')
                    if (values.cantidad_deuda <= 0 && values.metodo_intercambio !== 'normal')
                        setValues('metodo_intercambio', 'normal')

                    if (values.cantidad_deuda <= 0 && values.metodo_intercambio === 'normal')
                        setAditionalClass('hidden')
                    else
                        setAditionalClass('')
                },
                fieldDependency: 'cantidad_deuda',
                fieldDependencyExtra: 'metodo_intercambio',
            },
            {
                label: 'Método de pago de garantía',
                name: 'metodo_pago_garantia',
                type: 'select',
                required: true,
                disabled: disabled != null ? disabled : false,
                options: [
                    {
                        label: 'Efectivo',
                        value: 'efectivo'
                    },
                    {
                        label: 'Transferencia',
                        value: 'transferencia'
                    },
                    {
                        label: 'Cheque',
                        value: 'cheque'
                    },
                    {
                        label: 'Combinado E/T',
                        value: 'combinado'
                    },
                ],
                ChangeCondition: (values, setValues, setAditionalClass) => {
                    if (values.metodo_intercambio === 'garantía') {
                        setAditionalClass('')
                    } else {
                        setAditionalClass('hidden')
                        setValues('monto_garantia', 0)
                        setValues('monto_garantia_transferencia', 0)
                    }
                },
                fieldDependency: 'metodo_intercambio',
                highlight: 'bg-indigo-600 dark:bg-indigo-500 bg-opacity-25 dark:bg-opacity-20'
            },
            // {
            //     label: 'Monto de garantía',
            //     name: 'monto_garantia',
            //     type: 'groupnumber',
            //     subData: 'Bs.',
            //     required: false,
            //     disabled: disabled != null ? disabled : false,
            //     ChangeCondition: (values, setValues, setAditionalClass) => {
            //         if (values.metodo_intercambio === 'garantía')
            //             setAditionalClass('')
            //         else
            //             setAditionalClass('hidden')
            //     },
            //     fieldDependency: 'metodo_intercambio',
            //     highlight: 'bg-indigo-600 dark:bg-indigo-500 bg-opacity-25 dark:bg-opacity-20'
            // },
            {
                label: 'Garantía en efectivo',
                name: 'monto_garantia',
                type: 'groupnumber',
                subData: 'Bs.',
                required: false,
                disabled: disabled != null ? disabled : false,
                ChangeCondition: (values, setValues, setAditionalClass) => {
                    const visible = values.metodo_intercambio === 'garantía' && ['efectivo', 'combinado'].includes(values.metodo_pago_garantia)
                    if (visible) {
                        setAditionalClass('')
                    } else {
                        setAditionalClass('hidden')
                        if (Number(values.monto_garantia || 0) !== 0) {
                            setValues('monto_garantia', 0)
                        }
                    }
                },
                fieldDependency: 'metodo_intercambio',
                fieldDependencyExtra: 'metodo_pago_garantia',
                highlight: 'bg-indigo-600 dark:bg-indigo-500 bg-opacity-25 dark:bg-opacity-20'
            },
            {
                label: 'Garantía por transferencia',
                name: 'monto_garantia_transferencia',
                type: 'groupnumber',
                subData: 'Bs.',
                required: false,
                disabled: disabled != null ? disabled : false,
                ChangeCondition: (values, setValues, setAditionalClass) => {
                    const visible =
                        values.metodo_intercambio === 'garantía' &&
                        ['transferencia', 'cheque', 'combinado'].includes(values.metodo_pago_garantia)

                    if (visible) {
                        setAditionalClass('')
                    } else {
                        setAditionalClass('hidden')
                        if (Number(values.monto_garantia_transferencia || 0) !== 0) {
                            setValues('monto_garantia_transferencia', 0)
                        }
                    }
                },
                fieldDependency: 'metodo_intercambio',
                fieldDependencyExtra: 'metodo_pago_garantia',
                highlight: 'bg-indigo-600 dark:bg-indigo-500 bg-opacity-25 dark:bg-opacity-20'
            },
            {
                label: 'Fecha estimada de devolución',
                name: 'fecha_estimada_devolucion',
                type: 'date',
                disabled: disabled != null ? disabled : false,
                ChangeCondition: (values, setValues, setAditionalClass) => {
                    if (values.metodo_intercambio === 'préstamo')
                        setAditionalClass('')
                    else
                        setAditionalClass('hidden')
                },
                fieldDependency: 'metodo_intercambio',
                highlight: 'bg-cyan-600 dark:bg-cyan-500 bg-opacity-25 dark:bg-opacity-20'
            },
            {
                type: 'divider',
            },
            ...sharedFieldsVenta2({ tipo }),
            ...sharedEncargadoObs({ tipo })
        ]
    }
}

export const VentaNoRetornableValues = (cuaderno_id, user_id, tipo, disabled = null) => {
    return {
        initialValues: {
            ...sharedInitialValuesVenta({ cuaderno_id, tipo }),
        },
        fieldsValidation: Yup.object().shape({
            almacen_producto_id: StringRequired,
            precio_unitario: NumberRequired,
            cantidad: NumberIntegerMinOneRequired,
        }),
        fields: [
            ...sharedFieldsVenta1({ disabled, urlApiAlmacen: `/user/${user_id}/almacenes/no-retornable`, user_id, tipo }),
            ...sharedFieldsVenta2({ tipo }),
            ...sharedEncargadoObs({ tipo })
        ]
    }
}

export const GarantiaDirectaValues = (cuaderno_id, user_id, disabled = null) => {
    return {
        initialValues: {
            cuaderno_id: cuaderno_id,
            almacen_producto_id: '',
            user_id: '',
            cantidad_deuda: 0,
            metodo_pago_garantia: 'efectivo',
            monto_garantia: 0,
            cantidadTotal: 0,
            cantidad_total_restante: 0,
        },
        // fieldsValidation: Yup.object().shape({
        // }),
        fields: [
            {
                label: 'Seleccione producto de almacén',
                name: 'almacen_producto_id',
                type: 'selectSearchDetailCard',
                urlApi: `/user/${user_id}/almacenes/vacios`,
                required: true,
                disabled: disabled != null ? disabled : false,
                labelDescription: 'etiqueta',
                placeholder: 'Producto...',
                autoFocus: true,
                nameNumber: 'cantidadAlmacen',
                labelNumberRestante: 'Restante',
                nameNumberRestante: 'cantidad_total_restante',
                alterField: 'cantidadTotal', // referencia de cantidadAlmacen
                exclamationDefault: 'Seleccione un producto!',
                // exclamationRestante: 'Stock insuficiente!',
                infoTags: [
                    {
                        label: 'Producto',
                        data: 'producto_nombre'
                    },
                    {
                        label: 'Tipo',
                        data: 'tipoProducto'
                    },
                    {
                        label: 'En almacén',
                        data: 'cantidadAlmacen',
                        mark: true
                    },
                ]
            },
            {
                label: 'Cliente',
                name: 'user_id',
                type: 'selectSearch',
                urlApi: `/vendedor/${user_id}/clientes`,
                required: true,
                disabled: disabled != null ? disabled : false,
                labelDescription: 'etiqueta',
                placeholder: 'Cliente...',
                autoFocus: false,
            },
            {
                label: 'Cantidad deuda',
                name: 'cantidad_deuda',
                type: 'number',
                subData: null,
                required: true,
                disabled: false,
                highlight: 'bg-yellow-600 dark:bg-yellow-500 bg-opacity-25 dark:bg-opacity-20',
                locked: false,
                // ChangeCalculator: (values, setValues, e) => {
                //     const cantidad_deuda = e.target.valueAsNumber || 0;
                //     const cantidadAlmacen = values.cantidadAlmacen || 0;
                //     const cantidadRestante = ToTwoDecimal(cantidadAlmacen + cantidad_deuda)
                //     setValues('cantidad_total_restante', cantidadRestante)
                // },
            },
            {
                label: 'Método de pago de garantía',
                name: 'metodo_pago_garantia',
                type: 'select',
                required: true,
                disabled: disabled != null ? disabled : false,
                options: [
                    {
                        label: 'Efectivo',
                        value: 'efectivo'
                    },
                    {
                        label: 'Transferencia',
                        value: 'transferencia'
                    },
                    {
                        label: 'Cheque',
                        value: 'cheque'
                    },
                ],
                highlight: 'bg-indigo-600 dark:bg-indigo-500 bg-opacity-25 dark:bg-opacity-20'
            },
            {
                label: 'Monto de garantía',
                name: 'monto_garantia',
                type: 'groupnumber',
                subData: 'Bs.',
                required: false,
                disabled: disabled != null ? disabled : false,
                highlight: 'bg-indigo-600 dark:bg-indigo-500 bg-opacity-25 dark:bg-opacity-20'
            },
        ]
    }
}

export const ResetValues = (data) => {
    return {
        initialValues: {
        },
        fieldsValidation: Yup.object().shape({
        }),
        fields: []
    }
}

export const GastoValues = (cuaderno_id) => {
    return {
        initialValues: {
            cuaderno_id: cuaderno_id,
            estado_gasto_id: '',
            monto: 0,
            obs: '',

        },
        fieldsValidation: Yup.object().shape({
            estado_gasto_id: StringRequired,
            monto: NumberRequired,
        }),
        fields: [
            {
                label: 'Tipo de gasto',
                name: 'estado_gasto_id',
                type: 'selectSearch',
                urlApi: '/nombreEstado/Gastos vendedores/subEstados',
                required: true,
                labelDescription: 'nombre',
                placeholder: 'Tipo de gasto...',
                autoFocus: false,
                // defaultValue: { value: '1', label: 'Clientes' }
            },
            {
                label: 'Monto del Gasto',
                name: 'monto',
                type: 'groupnumber',
                subData: 'Bs.',
                required: true,

            },
            {
                label: 'Observaciones',
                name: 'obs',
                type: 'text',
                required: false,
                placeholder: 'Observaciones...',
                autoFocus: false
            },
        ]
    }
}

export const DevolucionDePrestamosValues = (cuaderno_id, user_id, tipo) => {
    return {
        initialValues: {
            cuaderno_id: cuaderno_id,
            deuda_envase_id: '',
            saldo: 0,
            saldo_restante: 0,
            cantidad: 0,
            obs: '',
            tipo: tipo,
            encargado_id: '',
            nro_boleta: ''
        },
        fieldsValidation: Yup.object().shape({
            cantidad: NumberIntegerMinOneRequired,
            saldo_restante: NumberIntegerRequired,
        }),
        fields: [
            {
                label: 'Seleccion un usuario',
                name: 'deuda_envase_id',
                type: 'selectSearchDetailCard',
                // param: 'user_id',
                urlApi: `/user/${user_id}/prestamos?tagFilter=${tipo}`,
                required: true,
                labelDescription: 'etiqueta',
                placeholder: 'Deudor...',
                autoFocus: true,
                nameNumber: 'saldo',
                labelNumberRestante: 'Restante',
                nameNumberRestante: 'saldo_restante',
                alterField: 'cantidad',
                exclamationDefault: 'Seleccione un deudor!',
                exclamationRestante: null,
                infoTags: [
                    {
                        label: 'Deudor',
                        data: 'envaseDeudorDetalles'
                    },
                    {
                        label: 'Producto',
                        data: 'producto_nombre'
                    },
                    {
                        label: 'Fecha',
                        data: 'createdAt',
                        isDateValue: true
                    },
                    {
                        label: 'Fecha límite',
                        data: 'fecha_limite',
                        isDateValue: true
                    },
                    {
                        label: 'Saldo',
                        data: 'saldo',
                        mark: true
                    },
                ]
            },
            {
                label: 'Envases devueltos',
                name: 'cantidad',
                type: 'numberCalculator',
                subData: null,
                required: true,
                ChangeCalculator: (values, setValues, e) => {
                    const cantidad = e.target.valueAsNumber || 0;
                    const saldo = values.saldo || 0;
                    const saldo_restante = saldo - cantidad
                    setValues('saldo_restante', saldo_restante)
                }
            },
            {
                label: 'Envases restantes',
                name: 'saldo_restante',
                type: 'numberCalculator',
                subData: null,
                required: true,
                locked: true,
                disabled: true,
                ChangeCalculator: (values, setValues, e) => {
                    const cantidad = e.target.valueAsNumber || 0;
                    const saldo = values.saldo || 0;
                    const saldo_restante = saldo - cantidad
                    setValues('saldo_restante', saldo_restante)
                },
                highlight: 'bg-red-600 dark:bg-red-500 bg-opacity-25 dark:bg-opacity-20'
            },
            ...sharedEncargadoObs({ tipo })
        ]
    }
}

export const DevolucionDeGarantiasValues = (cuaderno_id, user_id, tipo) => {
    return {
        initialValues: {
            cuaderno_id: cuaderno_id,
            deuda_envase_id: '',
            metodo_pago: 'efectivo',
            saldo: 0,
            saldo_restante: 0,
            cantidad: 0,
            cantidadTotal: 0,

            monto: 0,
            monto_transferencia: 0,

            monto_garantia: 0,
            monto_garantia_efectivo: 0,
            monto_garantia_transferencia: 0,

            monto_restante: 0,
            obs: '',
            tipo: tipo,
            encargado_id: '',
            nro_boleta: ''
        },
        fieldsValidation: Yup.object().shape({
            cantidad: NumberIntegerRequired,
            saldo_restante: NumberIntegerRequired,
        }),
        fields: [
            {
                label: 'Seleccion cliente',
                name: 'deuda_envase_id',
                type: 'selectSearchDetailCard',
                urlApi: `/user/${user_id}/garantias?tagFilter=${tipo}`,
                required: true,
                labelDescription: 'etiqueta',
                placeholder: 'Deudor...',
                autoFocus: true,
                nameNumber: 'saldo',
                labelNumberRestante: 'Restante',
                nameNumberRestante: 'saldo_restante',
                alterField: 'cantidad',
                className: 'row-span-3',
                exclamationDefault: 'Seleccione un deudor!',
                exclamationRestante: null,
                setAction: (setValues, data) => {
                    console.log(data)
                    if (data != null) {
                        setValues('monto_garantia_efectivo', data.monto_garantia_efectivo)
                        setValues('monto_garantia_transferencia', data.monto_garantia_transferencia)
                        setValues('monto_garantia', data.monto_garantia)
                        setValues('monto_restante', data.monto_garantia)
                    }
                    else {
                        setValues('monto_garantia_efectivo', 0)
                        setValues('monto_garantia_transferencia', 0)
                        setValues('monto_garantia', 0)
                        setValues('monto_restante', 0)
                        setValues('monto', 0)
                        setValues('cantidad', 0)
                        setValues('cantidad_restante', 0)
                    }
                },
                infoTags: [
                    {
                        label: 'Deudor',
                        data: 'envaseDeudorDetalles'
                    },
                    {
                        label: 'Producto',
                        data: 'producto_nombre'
                    },
                    {
                        label: 'Fecha',
                        data: 'createdAt',
                        isDateValue: true
                    },
                    {
                        label: 'Monto Garantía. Bs.',
                        data: 'monto_garantia',
                        mark: true,
                    },
                    {
                        label: 'Saldo',
                        data: 'saldo',
                        mark: true
                    },
                ]
            },
            {
                label: 'Método de pago',
                name: 'metodo_pago',
                type: 'select',
                required: true,
                options: [
                    {
                        label: 'Efectivo',
                        value: 'efectivo'
                    },
                    {
                        label: 'Transferencia',
                        value: 'transferencia'
                    },
                    {
                        label: 'Cheque',
                        value: 'cheque'
                    },
                    {
                        label: 'Combinado E/T',
                        value: 'combinado'
                    },
                ],
            },
            {
                label: 'Garantía restante',
                name: 'monto_restante',
                type: 'groupnumberCalculator',
                subData: 'Bs.',
                disabled: true,
                highlight: 'bg-red-600 dark:bg-red-500 bg-opacity-25 dark:bg-opacity-20'
            },
            {
                label: 'Envases restantes',
                name: 'saldo_restante',
                type: 'numberCalculator',
                subData: null,
                required: true,
                locked: true,
                disabled: true,
                ChangeCalculator: (values, setValues, e) => {
                    const cantidad = e.target.valueAsNumber || 0;
                    const saldo = values.saldo || 0;
                    const saldo_restante = saldo - cantidad
                    setValues('saldo_restante', saldo_restante)
                },
                // highlight: 'bg-red-600 dark:bg-red-500 bg-opacity-25 dark:bg-opacity-20'
            },
            {
                type: 'divider',
                className: 'col-span-9'
            },
            {
                label: 'Efectivo devuelto',
                name: 'monto',
                type: 'groupnumberCalculator',
                subData: 'Bs.',
                // disabled: true,
                ChangeCalculator: (values, setValues, e) => {
                    const monto = e.target.valueAsNumber || 0;
                    const monto_transferencia = values.monto_transferencia || 0
                    const monto_garantia = values.monto_garantia || 0
                    console.log(values)
                    const monto_restante = monto_garantia - (monto_transferencia + monto)
                    setValues('monto_restante', monto_restante)
                },
                // ChangeCondition: (values, setValues, setAditionalClass) => {
                //     setValues('monto', 0)
                //     setValues('monto_transferencia', 0)
                //     setValues('monto_restante', values.monto_garantia)
                //     if (['efectivo', 'combinado'].includes(values.metodo_pago))
                //         setAditionalClass('')
                //     else
                //         setAditionalClass('hidden')
                // },
                ChangeCondition: (values, setValues, setAditionalClass) => {
                    const visible = ['efectivo', 'combinado'].includes(values.metodo_pago)
                    
                    if (visible) {
                        setAditionalClass('')
                    } else {
                        setAditionalClass('hidden')
                        
                        if (Number(values.monto || 0) !== 0) setValues('monto', 0)

                        const mg = Number(values.monto_garantia || 0)
                        const tr = Number(values.monto_transferencia || 0)
                        setValues('monto_restante', mg - tr)
                    }
                },
                fieldDependencyExtra: 'metodo_pago',
                highlight: 'bg-green-600 dark:bg-green-500 bg-opacity-25 dark:bg-opacity-20'
            },
            {
                label: 'Transferencia devuelta',
                name: 'monto_transferencia',
                type: 'groupnumberCalculator',
                subData: 'Bs.',
                // disabled: true,
                ChangeCalculator: (values, setValues, e) => {
                    const monto_transferencia = e.target.valueAsNumber || 0;
                    const monto_garantia = values.monto_garantia || 0
                    const monto = values.monto || 0
                    const monto_restante = monto_garantia - (monto + monto_transferencia)
                    setValues('monto_restante', monto_restante)
                },
                // ChangeCondition: (values, setValues, setAditionalClass) => {
                //     setValues('monto', 0)
                //     setValues('monto_transferencia', 0)
                //     setValues('monto_restante', values.monto_garantia)
                //     if (['transferencia', 'cheque', 'combinado'].includes(values.metodo_pago))
                //         setAditionalClass('')
                //     else
                //         setAditionalClass('hidden')
                // },
                ChangeCondition: (values, setValues, setAditionalClass) => {
                    const visible = ['transferencia', 'cheque', 'combinado'].includes(values.metodo_pago)
                    
                    if (visible) {
                        setAditionalClass('')
                    } else {
                        setAditionalClass('hidden')
                        
                        if (Number(values.monto_transferencia || 0) !== 0) setValues('monto_transferencia', 0)
                            
                        const mg = Number(values.monto_garantia || 0)
                        const ef = Number(values.monto || 0)
                        setValues('monto_restante', mg - ef)
                    }
                },
                
                fieldDependencyExtra: 'metodo_pago',
                highlight: 'bg-green-600 dark:bg-green-500 bg-opacity-25 dark:bg-opacity-20'
            },
            {
                label: 'Envases recogidos',
                name: 'cantidad',
                type: 'numberCalculator',
                subData: null,
                required: true,
                ChangeCalculator: (values, setValues, e) => {
                    const cantidad = e.target.valueAsNumber || 0;
                    const saldo = values.saldo || 0;
                    const saldo_restante = saldo - cantidad
                    setValues('saldo_restante', saldo_restante)
                },
                fieldDependency: 'metodo_pago',
            },
            ...sharedEncargadoObs({ tipo })
        ]
    }
}

export const CobrosValues = (cuaderno_id, user_id) => {
  return {
    initialValues: {
      cuaderno_id,
      deuda_id: '',
      metodo_pago: 'efectivo',
      saldo: 0,
      saldo_restante: 0,

      monto: 0,               // efectivo
      monto_transferencia: 0, // transferencia

      obs: '',
    },
    fieldsValidation: Yup.object().shape({
      saldo_restante: NumberIntegerRequired,
    }),
    fields: [
      {
        label: 'Seleccion un usuario',
        name: 'deuda_id',
        type: 'selectSearchDetailCard',
        urlApi: `/user/${user_id}/deudas`,
        required: true,
        labelDescription: 'etiqueta',
        placeholder: 'Deudor...',
        autoFocus: true,
        nameNumber: 'saldo',
        labelNumberRestante: 'Restante',
        nameNumberRestante: 'saldo_restante',
        alterField: 'monto',
        exclamationDefault: 'Seleccione un deudor!',
        exclamationRestante: 'El resto debe ser mayor o igual a 0!',
        setAction: (setValues, data) => {
          if (data != null) {
            setValues('monto', 0)
            setValues('monto_transferencia', 0)
            setValues('saldo_restante', data.saldo)
          } else {
            setValues('monto', 0)
            setValues('monto_transferencia', 0)
            setValues('saldo_restante', 0)
          }
        },
        infoTags: [
          { label: 'Deudor', data: 'deudorDetalles' },
          { label: 'Producto', data: 'producto_nombre' },
          { label: 'Fecha', data: 'createdAt', isDateValue: true },
          { label: 'Saldo', data: 'saldo', mark: true },
        ]
      },

      {
        label: 'Método de pago',
        name: 'metodo_pago',
        type: 'select',
        required: true,
        options: [
          { label: 'Efectivo', value: 'efectivo' },
          { label: 'Transferencia', value: 'transferencia' },
          { label: 'Cheque', value: 'cheque' },
          { label: 'Combinado E/T', value: 'combinado' },
        ],
      },

      {
        label: 'Saldo',
        name: 'saldo',
        type: 'groupnumber',
        subData: 'Bs.',
        disabled: true,
        highlight: 'bg-green-600 dark:bg-green-500 bg-opacity-25 dark:bg-opacity-20'
      },

      // ✅ efectivo
      {
        label: 'Monto cobrado (efectivo)',
        name: 'monto',
        type: 'groupnumberCalculator',
        subData: 'Bs.',
        ChangeCalculator: (values, setValues, e) => {
          const ef = e.target.valueAsNumber || 0
          const tr = values.monto_transferencia || 0
          const saldo = values.saldo || 0
          setValues('saldo_restante', saldo - (ef + tr))
        },
        ChangeCondition: (values, setValues, setAditionalClass) => {
          setValues('monto', 0)
          setValues('monto_transferencia', 0)
          setValues('saldo_restante', values.saldo || 0)

          if (['efectivo', 'combinado'].includes(values.metodo_pago)) setAditionalClass('')
          else setAditionalClass('hidden')
        },
        fieldDependency: 'metodo_pago',
      },

      // ✅ transferencia
      {
        label: 'Monto cobrado (transferencia)',
        name: 'monto_transferencia',
        type: 'groupnumberCalculator',
        subData: 'Bs.',
        ChangeCalculator: (values, setValues, e) => {
          const tr = e.target.valueAsNumber || 0
          const ef = values.monto || 0
          const saldo = values.saldo || 0
          setValues('saldo_restante', saldo - (ef + tr))
        },
        ChangeCondition: (values, setValues, setAditionalClass) => {
          setValues('monto', 0)
          setValues('monto_transferencia', 0)
          setValues('saldo_restante', values.saldo || 0)

          if (['transferencia', 'cheque', 'combinado'].includes(values.metodo_pago)) setAditionalClass('')
          else setAditionalClass('hidden')
        },
        fieldDependency: 'metodo_pago',
      },

      {
        label: 'Saldo restante',
        name: 'saldo_restante',
        type: 'groupnumber',
        subData: 'Bs.',
        disabled: true,
        highlight: 'bg-red-600 dark:bg-red-500 bg-opacity-25 dark:bg-opacity-20'
      },

      {
        label: 'Observaciones',
        name: 'obs',
        type: 'textArea',
        required: false,
        placeholder: 'Observaciones...',
      },
    ]
  }
}

export const VentaCambiarFecha = (venta, user_id) => {
    return {
        initialValues: {
            cuaderno_id: venta.cuaderno_id,
            createdAt: venta.createdAt
        },
        fieldsValidation: Yup.object().shape({
        }),
        fields: [
            {
                label: 'Fecha',
                name: 'createdAt',
                type: 'datetime',
                required: true,
                placeholder: 'Fecha...',
                autoFocus: false
            }
        ]
    }
}

export const VentaCambiarObs = (venta, user_id) => {
    return {
        initialValues: {
            cuaderno_id: venta.cuaderno_id,
            obs: venta.obs ?? ''
        },
        fieldsValidation: Yup.object().shape({
        }),
        fields: [
            {
                label: 'Observaciones',
                name: 'obs',
                type: 'textArea',
                required: false,
                placeholder: 'Observaciones...',
                autoFocus: false
            },
        ]
    }
}

export const DeleteValues = (data) => {
    return {
        initialValues: {
        },
        fieldsValidation: Yup.object().shape({
        }),
        fields: []
    }
}


export const VentaEditarMontos = (venta = {}) => {
  const n = (v) => {
    if (v === null || v === undefined || v === '') return 0;
    if (typeof v === 'number') return v;

    let s = String(v).trim();
    if (!s) return 0;
    s = s.replace(/\s/g, '').replace(/[^\d.,-]/g, '');

    const hasDot = s.includes('.');
    const hasComma = s.includes(',');

    if (hasDot && hasComma) {
        s = s.replace(/\./g, '').replace(',', '.');
    } else if (hasDot && !hasComma) {
        if (/^-?\d{1,3}(\.\d{3})+$/.test(s)) {
        s = s.replace(/\./g, '');
        }
    } else if (!hasDot && hasComma) {
        s = s.replace(',', '.');
    }

    const num = parseFloat(s);
    return Number.isFinite(num) ? num : 0;
    };
  const r2 = (v) => Math.round((v + Number.EPSILON) * 100) / 100;

  const nombre =
    `${venta?.user_nombres ?? ''} ${venta?.user_apellido_paterno ?? ''} ${venta?.user_apellido_materno ?? ''}`.trim();

  const cantidad = n(venta?.cantidad);

  const fechaRegistroText = (() => {
    const d = new Date(venta?.createdAt ?? '');
    return isNaN(d.getTime()) ? '' : d.toLocaleString();
  })();
const recomputeDeuda = (values, { efectivoOverride, transfOverride, ventaOverride } = {}) => {
    const venta_total = (ventaOverride !== undefined) ? ventaOverride : (n(values.venta_total) || 0);
    const efec = (efectivoOverride !== undefined) ? efectivoOverride : (n(values.efectivo_total) || 0);
    const transf = (transfOverride !== undefined) ? transfOverride : (n(values.transferencia_total) || 0);
    return r2(venta_total - efec - transf);
};

const ajustarContraSaldo = (values, setValues, nuevaDeuda) => {
    const venta_total = n(values.venta_total) || 0;
    const efec = n(values.efectivo_total) || 0;
    const transf = n(values.transferencia_total) || 0;
    const metodo = values.metodo_pago;

    if (metodo === 'efectivo' || metodo === 'combinado') {
        const nuevoEfec = r2(venta_total - transf - nuevaDeuda);
        setValues('efectivo_total', Math.max(0, nuevoEfec));
    } else {
        const nuevoTransf = r2(venta_total - efec - nuevaDeuda);
        setValues('transferencia_total', Math.max(0, nuevoTransf));
    }
  };

  return {
    initialValues: {
      vendido_a: nombre,
      producto: venta?.producto_nombre ?? '',
      metodo_intercambio: venta?.metodo_intercambio ?? '',
      tipo: venta?.tipo ?? '',
      createdAt_text: fechaRegistroText,
      cantidad,
      cantidad_retorno: n(venta?.cantidad_retorno),
      cantidad_deuda: n(venta?.cantidad_deuda),
      metodo_pago: venta?.metodo_pago ?? '',

      precio_unitario: n(venta?.precio_unitario),
      venta_total: n(venta?.venta_total),
      efectivo_total: n(venta?.efectivo_total),
      transferencia_total: n(venta?.transferencia_total),
      monto_garantia: n(venta?.monto_garantia ?? venta?.monto_garantia_string),
      monto_garantia_transferencia: n(
        venta?.monto_garantia_transferencia ?? venta?.monto_garantia_transferencia_string
      ),
      deuda_total: n(venta?.deuda_total),

      metodo_pago_garantia: venta?.metodo_pago_garantia ?? '',

      fecha_estimada_cobro: venta?.fecha_estimada_cobro ?? '',

      obs: venta?.obs ?? '',
    },

    fields: [
      { label: 'Vendido a', name: 'vendido_a', type: 'text', disabled: true },
      { label: 'Producto', name: 'producto', type: 'text', disabled: true },
      { label: 'Intercambio', name: 'metodo_intercambio', type: 'text', disabled: true },
      { label: 'Tipo', name: 'tipo', type: 'text', disabled: true },
      { label: 'Fecha de registro', name: 'createdAt_text', type: 'text', disabled: true },
      { label: 'Cantidad', name: 'cantidad', type: 'number', disabled: true },
      { label: 'Cantidad recogido', name: 'cantidad_retorno', type: 'number', disabled: true },
      { label: 'Cantidad deuda', name: 'cantidad_deuda', type: 'number', disabled: true },
      { label: 'Método de pago', name: 'metodo_pago', type: 'text', disabled: true },

      { type: 'divider' },


      {
        label: 'Precio unitario',
        name: 'precio_unitario',
        type: 'groupnumberCalculator',
        subData: 'Bs.',
        required: true,
        ChangeCalculator: (values, setValues, e) => {
          const pu = e.target.valueAsNumber || 0;
          const vt = r2((values.cantidad || 0) * pu);
          setValues('precio_unitario', Math.max(0, pu));
          setValues('venta_total', vt);
          const deuda = recomputeDeuda(values, { ventaOverride: vt });
          setValues('deuda_total', Math.max(0, deuda));
        },
      },

      {
        label: 'Venta total',
        name: 'venta_total',
        type: 'groupnumberCalculator',
        subData: 'Bs.',
        required: true,
        ChangeCalculator: (values, setValues, e) => {
          const vt = e.target.valueAsNumber || 0;
          setValues('venta_total', Math.max(0, vt));
          const deuda = recomputeDeuda(values, { ventaOverride: vt });
          setValues('deuda_total', Math.max(0, deuda));
        },
        ChangeCondition: (values, setValues) => {
          const vt = r2((values.cantidad || 0) * (values.precio_unitario || 0));
          setValues('venta_total', vt);
          const deuda = recomputeDeuda(values, { ventaOverride: vt });
          setValues('deuda_total', Math.max(0, deuda));
        },
        fieldDependency: 'precio_unitario',
        fieldDependencyExtra: 'cantidad',
      },

      {
        label: 'Efectivo',
        name: 'efectivo_total',
        type: 'groupnumberCalculator',
        subData: 'Bs.',
        required: true,
        ChangeCalculator: (values, setValues, e) => {
          const ef = e.target.valueAsNumber || 0;
          setValues('efectivo_total', Math.max(0, ef));
          const deuda = recomputeDeuda(values, { efectivoOverride: ef });
          setValues('deuda_total', Math.max(0, deuda));
        },
        ChangeCondition: (values, setValues, setClass) => {
          if (['efectivo', 'combinado'].includes(values.metodo_pago)) {
            setClass('');
          } else {
            setClass('hidden');
            setValues('efectivo_total', 0);
            const deuda = recomputeDeuda(values, { efectivoOverride: 0 });
            setValues('deuda_total', Math.max(0, deuda));
          }
        },
        fieldDependency: 'metodo_pago',
        highlight: 'bg-green-600 dark:bg-green-500 bg-opacity-25 dark:bg-opacity-20',
      },

      {
        label: 'Transferencia',
        name: 'transferencia_total',
        type: 'groupnumberCalculator',
        subData: 'Bs.',
        required: true,
        ChangeCalculator: (values, setValues, e) => {
          const tr = e.target.valueAsNumber || 0;
          setValues('transferencia_total', Math.max(0, tr));
          const deuda = recomputeDeuda(values, { transfOverride: tr });
          setValues('deuda_total', Math.max(0, deuda));
        },
        ChangeCondition: (values, setValues, setClass) => {
          if (['transferencia', 'cheque', 'combinado'].includes(values.metodo_pago)) {
            setClass('');
          } else {
            setClass('hidden');
            setValues('transferencia_total', 0);
            const deuda = recomputeDeuda(values, { transfOverride: 0 });
            setValues('deuda_total', Math.max(0, deuda));
          }
        },
        fieldDependency: 'metodo_pago',
        highlight: 'bg-gray-600 dark:bg-gray-500 bg-opacity-25 dark:bg-opacity-20',
      },

      {
        label: 'Saldo Bs.',
        name: 'deuda_total',
        type: 'groupnumberCalculator',
        subData: 'Bs.',
        required: true,
        ChangeCalculator: (values, setValues, e) => {
          const nuevaDeuda = Math.max(0, e.target.valueAsNumber || 0);
          setValues('deuda_total', nuevaDeuda);
          ajustarContraSaldo(values, setValues, nuevaDeuda);
        },
      },

      {
        label: 'Fecha estimada de cobro',
        name: 'fecha_estimada_cobro',
        type: 'date',
        required: false,
        ChangeCondition: (values, _setValues, setClass) => {
          setClass(n(values.deuda_total) > 0 ? '' : 'hidden');
        },
        fieldDependency: 'deuda_total',
      },

      { type: 'divider' },


      { label: 'Método de pago de garantía', name: 'metodo_pago_garantia', type: 'text',
        disabled: true,
        ChangeCondition: (values, _setValues, setClass) => {
          setClass(values.metodo_intercambio === 'garantía' ? '' : 'hidden');
        },
        fieldDependency: 'metodo_intercambio',
      },

      {
        label: 'Garantía efectivo',
        name: 'monto_garantia',
        type: 'groupnumberCalculator',
        subData: 'Bs.',
        required: false,
        ChangeCalculator: (_values, setValues, e) => {
          const v = e.target.valueAsNumber || 0;
          setValues('monto_garantia', Math.max(0, v));
        },
        ChangeCondition: (values, setValues, setClass) => {
          if (values.metodo_intercambio !== 'garantía') {
            setClass('hidden'); setValues('monto_garantia', 0); return;
          }
          if (['efectivo', 'combinado'].includes(values.metodo_pago_garantia)) {
            setClass('');
          } else {
            setClass('hidden'); setValues('monto_garantia', 0);
          }
        },
        fieldDependency: 'metodo_intercambio',
        fieldDependencyExtra: 'metodo_pago_garantia',
        highlight: 'bg-indigo-600 dark:bg-indigo-500 bg-opacity-25 dark:bg-opacity-20',
      },

      {
        label: 'Garantía transferencia',
        name: 'monto_garantia_transferencia',
        type: 'groupnumberCalculator',
        subData: 'Bs.',
        required: false,
        ChangeCalculator: (_values, setValues, e) => {
          const v = e.target.valueAsNumber || 0;
          setValues('monto_garantia_transferencia', Math.max(0, v));
        },
        ChangeCondition: (values, setValues, setClass) => {
          if (values.metodo_intercambio !== 'garantía') {
            setClass('hidden'); setValues('monto_garantia_transferencia', 0); return;
          }
          if (['transferencia', 'cheque', 'combinado'].includes(values.metodo_pago_garantia)) {
            setClass('');
          } else {
            setClass('hidden'); setValues('monto_garantia_transferencia', 0);
          }
        },
        fieldDependency: 'metodo_intercambio',
        fieldDependencyExtra: 'metodo_pago_garantia',
        highlight: 'bg-indigo-600 dark:bg-indigo-500 bg-opacity-25 dark:bg-opacity-20',
      },

      { label: 'Observaciones', name: 'obs', type: 'textArea' },
    ],
  };
};
